import { render, staticRenderFns } from "./Filter.vue?vue&type=template&id=80b67a4e"
import script from "./Filter.vue?vue&type=script&lang=ts"
export * from "./Filter.vue?vue&type=script&lang=ts"
import style0 from "./Filter.vue?vue&type=style&index=0&id=80b67a4e&prod&lang=scss"
import style1 from "./Filter.vue?vue&type=style&index=1&id=80b67a4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports